<template>
  <v-card-actions>
    <v-spacer></v-spacer>
    <span v-if="item.read">
      <v-tooltip bottom>
        <v-btn icon small flat slot="activator" class="disable-events">
          <v-icon color="primary lighten-1">done_all</v-icon>
        </v-btn>
        <span>Leído</span>
      </v-tooltip>
    </span>
    <span v-else>
      <v-tooltip bottom>
        <v-btn icon small flat @click="markAsRead" slot="activator">
          <v-icon color="red lighten-1">visibility</v-icon>
        </v-btn>
        <span>No leído</span>
      </v-tooltip>
    </span>
    <v-tooltip bottom>
      <v-btn icon small flat @click="goRoute" slot="activator" class="button-table"
             v-if="item.notification.contentType">
        <v-icon color="primary">keyboard_arrow_right</v-icon>
      </v-btn>
      <span>Ver</span>
    </v-tooltip>
  </v-card-actions>
</template>

<script>
import constants from '../constants'

export default {
  props: {
    item: Object
  },

  methods: {
    markAsRead () {
      if (!this.item.read) {
        this.axios
          .put(`notification/read/${this.item.notification.id}`)
          .then(() => (this.item.read = true))
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
    },
    goRoute () {
      this.markAsRead()
      let contentType = this.item.notification.contentType
      if (contentType === 'Liquidaciones') {
        contentType = this.item.notification.contentTypeClass
      }
      if (contentType === 'Expedientes') {
        return this.$router.push({ name: 'expedientes' })
      }
      this.$router.push({
        name: constants.NOTIFICATION_ROUTES[contentType],
        params: { id: this.item.notification.objectId }
      })
    }
  }
}
</script>

<style scoped>
.button-table {
  margin-left: 0.5em;
}
.disable-events {
  pointer-events: none
}
</style>
